import React, { useRef } from "react";
import { Bold, Italic, List, ListOrdered } from "lucide-react";

const TOOLS = [
  { icon: Bold, label: "Bold", wrap: ["**", "**"] },
  { icon: Italic, label: "Italic", wrap: ["_", "_"] },
  { icon: List, label: "Bullet list", prefix: "- " },
  { icon: ListOrdered, label: "Numbered list", prefix: "1. " },
];

export function RichTextEditor({ value = "", onChange, placeholder, rows = 6, testId }) {
  const ref = useRef(null);

  const apply = (tool) => {
    const el = ref.current;
    if (!el) return;
    const { selectionStart: s, selectionEnd: e } = el;
    let next, cursor;
    if (tool.wrap) {
      const sel = value.slice(s, e) || "text";
      next = value.slice(0, s) + tool.wrap[0] + sel + tool.wrap[1] + value.slice(e);
      cursor = s + tool.wrap[0].length + sel.length + tool.wrap[1].length;
    } else {
      const lineStart = value.lastIndexOf("\n", s - 1) + 1;
      next = value.slice(0, lineStart) + tool.prefix + value.slice(lineStart);
      cursor = s + tool.prefix.length;
    }
    onChange(next);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(cursor, cursor); });
  };

  return (
    <div className="rounded-xl border border-border bg-white focus-within:border-coral focus-within:ring-4 focus-within:ring-coral/10 transition-shadow">
      <div className="flex items-center gap-1 px-2 py-1.5 border-b border-border">
        {TOOLS.map((t) => (
          <button key={t.label} type="button" title={t.label} aria-label={t.label} onMouseDown={(ev) => ev.preventDefault()} onClick={() => apply(t)}
            data-testid={`${testId || "rte"}-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="grid place-items-center w-9 h-9 rounded-lg text-ink-soft hover:bg-secondary hover:text-ink transition-colors">
            <t.icon size={16} />
          </button>
        ))}
        <span className="ml-auto text-[11px] font-semibold text-ink-soft/70 hidden sm:inline">**bold** · _italic_ · - list</span>
      </div>
      <textarea ref={ref} rows={rows} value={value} onChange={(ev) => onChange(ev.target.value)} placeholder={placeholder}
        data-testid={testId}
        className="w-full resize-y rounded-b-xl px-4 py-3 outline-none font-medium bg-transparent text-base leading-relaxed" />
    </div>
  );
}
